import { ContrastVariantProps } from 'common/Prose/nodeViews/Image/components/ImageVariant/Types'
import { ImageVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant'
import { contrast } from '@cloudinary/url-gen/actions/adjust'
import { useImageStore } from 'stores/ImageStore'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { SliderField } from './SliderField'

export const ContrastVariant = (props: ContrastVariantProps) => {
  const { variant } = props
  const imageStore = useImageStore()
  const cloudinary = useCloudinary()

  if (!cloudinary) return null

  return (
    <ImageVariant {...props}>
      <SliderField
        minValue={-100}
        maxValue={100}
        step={1}
        initialValue={variant.qualifier ?? 0}
        label="Change color contrast"
        onChangeEnd={(value) => {
          const image = cloudinary.image(variant.sourceUrl.split('?')[0]).setDeliveryType('fetch')
          image.effect(contrast(value) as any)
          imageStore.clearVariants()
          imageStore.createVariant({ image, url: image.toURL(), action: 'contrast', qualifier: value })
        }}
      />
    </ImageVariant>
  )
}
